import React, { useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseAuthTermsCollect.module.scss'

const cx = className.bind(style)

const MyhouseAuthTermsCollect: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={cx('terms')}>
      <h3 className={cx('title')}>개인정보 수집 및 이용 동의</h3>
      <dl className={cx('list')}>
        <dd className={cx('text')}>
          ‘네이버파이낸셜㈜’는 네이버파이낸셜 회원들의 개인(신용)정보를 안전하게 처리하는데 최선을 다합니다. 네이버파이낸셜 서비스 이용을 위해서는 아래의 개인(신용)정보 동의가
          필요합니다. 자세히 읽은 후 동의하여 주시기 바랍니다.
        </dd>
      </dl>
      <dl className={cx('list')}>
        <dt className={cx('subtitle')}>1. 수집항목</dt>
        <dd className={cx('text')}>제출물(관리비 고지서 또는 택배/우편물 사진)에 포함된 주소지</dd>
      </dl>
      <dl className={cx('list')}>
        <dt className={cx('subtitle')}>2. 수집 및 이용 목적</dt>
        <dd className={cx('text')}>입주민 인증 성공/실패 처리를 위한 서비스 운영</dd>
      </dl>
      <dl className={cx('list', 'type_emphasis')}>
        <dt className={cx('subtitle')}>3. 보유 및 이용기간</dt>
        <dd className={cx('text')}>입주민 인증 성공/실패 처리로부터 7일까지(단, 제출물에 불필요한 개인정보가 포함된 경우에는 즉시 폐기함)</dd>
      </dl>
      <dl className={cx('list')}>
        <dd className={cx('text')}>
          개인(신용)정보주체는 위 개인(신용)정보 동의를 거부할 권리가 있으나, 위 동의는 서비스 제공을 위해 필수적이므로 거부 시 서비스 제공에 제한을 받을 수 있습니다. 그 밖의
          사항은 네이버파이낸셜 개인정보 처리방침에 따릅니다.
        </dd>
      </dl>
    </div>
  )
}

export default MyhouseAuthTermsCollect
